import styled from 'styled-components';

export const SelectDepartmentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 88px ${({ theme }) => theme.spacing.m};
  gap: ${({ theme }) => theme.spacing.m};
`;

export const TemplateSelectionContainert = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};
`;

export const DeparrtmentSelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};
`;
